<template>
    <label class="field field-type-select">
        <select :id="`field-${name}-input`"
                :name="name"
                :aria-labelledby="`field-${name}-label`"
                class="field-input"
                :multiple="multiple"
                :value="value"
                @input="updateValue"
        >
            <option v-for="(label, value) in options" :key="value" :value="value" :selected="isSelected(value)">
                {{ label }}
            </option>
        </select>
        <span :id="`field-${name}-label`"
              class="field-label"
              aria-hidden="true"
        >
            {{ label || '' }}
        </span>
        <icon class="chevron-icon" name="expand_more"/>
    </label>
</template>

<script>
  import Icon      from '../Layout/Icon';
  import BaseField from './BaseField';

  /**
   * @property {Event} $event
   */
  export default {
    name:       'SelectField',
    components: { Icon },
    extends:    BaseField,

    props: {
      value: {
        type:    Array,
        default: () => [],
      },

      options: {
        type:    Object,
        default: () => ( {} ),
      },

      multiple: {
        type:    Boolean,
        default: false,
      },
    },

    methods: {
      updateValue ( event ) {
        this.$emit('input', [ ...this.value, event.target.value ]);
      },

      isSelected ( item ) {
        return this.value.includes(item);
      },
    },
  };
</script>

<style scoped>
    .field.field-select {
        position: relative;
    }

    .field.field-select .field-input {
        padding-right: 1.5rem;
    }

    .chevron-icon {
        order:          3;
        position:       absolute;
        pointer-events: none;
        right:          0;
        top:            1rem;
        font-size:      1rem;
        user-select:    none;
    }
</style>
